import { render, staticRenderFns } from "./MassCustomerCategoriesStepUploads.vue?vue&type=template&id=5fbc046e&scoped=true&"
import script from "./MassCustomerCategoriesStepUploads.vue?vue&type=script&lang=js&"
export * from "./MassCustomerCategoriesStepUploads.vue?vue&type=script&lang=js&"
import style0 from "./MassCustomerCategoriesStepUploads.vue?vue&type=style&index=0&id=5fbc046e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc046e",
  null
  
)

export default component.exports